import React from 'react'
import styled from 'styled-components'
import {palette} from 'styled-tools'
import Image from 'next/image'
import ArrowRightUpLineIcon from 'remixicon-react/ArrowRightUpLineIcon'

import Link from 'next/link'
import theme from '../../themes/theme'
import {H6, PSmall} from '../typography'
import shadowStyles from '../../styles/shadowStyles'
import {BackgroundImageCover} from '../../styles/imageStyles'

const CategoryTitleBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px;
  color: ${palette('secondary')};
  background: ${palette('white')};
  border: 1px solid ${palette('black20')};
  transition: background-color 0.15s;

  ${H6} {
    position: relative;
    padding-top: 16px;
    padding-bottom: 8px;

    &:before {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 20px;
      border-top: 1px solid ${palette('red')};
    }
  }
`

export const IconContainer = styled.div`
  visibility: hidden;
  position: absolute;
  top: 0;
  right: 0;
  transition: visibility 0.15s;
`

const CardWrapper = styled.a`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 250px;
  margin-bottom: 20px;
  transition: color 0.5s, border-color 0.5s, background-color 0.5s;
  border: 1px solid transparent;
  cursor: pointer;
  ${shadowStyles({
    color: 'red',
    outlined: false,
    length: 8,
    showOnHover: true,
  })};

  &:hover&:not(:disabled) {
    border: 1px solid ${palette('red')};

    ${IconContainer} {
      visibility: visible;
    }
  }

  &:active {
    ${CategoryTitleBox} {
      background-color: ${palette('red10')};
    }
  }

  ${BackgroundImageCover} {
    background-color: ${palette('white')};
  }

  &:focus,
  &:focus-visible {
    outline: 3px solid ${palette('sky')};
  }
`
interface Props {
  src?: string
  title?: string
  description?: string
  href?: string
}

export default function CategoryCard({
  src,
  title,
  description,
  href,
}: Props): JSX.Element | null {
  if (!href) {
    return null
  }
  return (
    <Link href={href} passHref>
      <CardWrapper>
        {src ? (
          <BackgroundImageCover>
            <Image
              layout="fill"
              objectFit="contain"
              objectPosition="center"
              src={src}
            />
          </BackgroundImageCover>
        ) : null}
        <CategoryTitleBox>
          <IconContainer>
            <ArrowRightUpLineIcon color={theme.palette.red} />
          </IconContainer>
          <H6>{title || 'Vöruflokkur'}</H6>
          <PSmall color="black40">{description}</PSmall>
        </CategoryTitleBox>
      </CardWrapper>
    </Link>
  )
}
